import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { HttpService } from "./../../services/http.service";
import { ToolsService } from "./../../services/tools.service";
import { GroupeDialogComponent } from "./groupe-dialog";
import { ToastrService } from "./../../components/_toastr/toastr.service";
import { Groupe } from "../../interfaces/Groupe";

@Injectable({
  providedIn: "root",
})
export class GroupeDialogService {
  constructor(
    private _dialog: MatDialog,
    private _http: HttpService,
    private _tools: ToolsService,
    private _toastr: ToastrService
  ) {}

  openDialog(groupe_ID: number, callBack: Function = () => {}): void {
    const dialogRef = this._dialog.open(GroupeDialogComponent, {
      width: "700px",
      data: groupe_ID,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && callBack) {
        callBack();
      }
    });
  }

  get(groupe_ID: number, callBack: Function): void {
    this._http.GET(
      "/api/groupe/" + groupe_ID,
      null,
      (result) => {
        if (result.isOk) {
          callBack(result.obj);
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  post(groupe: Groupe, callBack: Function): void {
    this._http.POST(
      "/api/groupe",
      groupe,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Groupe enregistré avec succès",
            type: "success",
          });
          // Retourner l'objet mis à jour avec le nouvel ID si c'est une création
          if (result.obj && result.obj.groupe_ID) {
            callBack(result.obj);
          } else {
            callBack(groupe);
          }
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  delete(groupe_ID: number, callBack: Function): void {
    this._http.DELETE(
      "/api/groupe/" + groupe_ID,
      null,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Groupe supprimé avec succès",
            type: "success",
          });
          callBack();
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }
}
